/**
 * @desc 编辑成本信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmSkuCostInfoRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editCostInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
